<!-- BEGIN #header -->
<div id="header" class="app-header" [attr.data-bs-theme]="this.appSettings.appHeaderInverse ? 'dark' : ''">
	<!-- BEGIN navbar-header -->
	<div class="navbar-header">
		<button type="button" class="navbar-mobile-toggler" *ngIf="this.appSidebarTwo"
			(click)="toggleAppSidebarEndMobile()">
			<span class="icon-bar"></span>
			<span class="icon-bar"></span>
			<span class="icon-bar"></span>
		</button>
		<a href="/kisna-live-dashboard" class="ms-3"> <img src="/assets/kisna/kisna.png" name="kinsa" height="30" />
		</a>

		<button type="button" class="navbar-mobile-toggler" (click)="toggleAppTopMenuMobile()"
			*ngIf="this.appSettings.appTopMenu && !this.appSettings.appSidebarNone">
			<span class="fa-stack fa-lg text-inverse">
				<i class="far fa-square fa-stack-2x"></i>
				<i class="fa fa-cog fa-stack-1x"></i>
			</span>
		</button>
		<button type="button" class="navbar-mobile-toggler" (click)="toggleAppHeaderMegaMenuMobile()"
			*ngIf="this.appSettings.appHeaderMegaMenu">
			<span class="fa-stack fa-lg text-inverse">
				<i class="far fa-square fa-stack-2x"></i>
				<i class="fa fa-cog fa-stack-1x"></i>
			</span>
		</button>
		<button type="button" class="navbar-mobile-toggler" (click)="toggleAppSidebarMobile()"
			*ngIf="!this.appSettings.appSidebarNone">
			<span class="icon-bar"></span>
			<span class="icon-bar"></span>
			<span class="icon-bar"></span>
		</button>
		<button type="button" class="navbar-mobile-toggler" (click)="toggleAppTopMenuMobile()"
			*ngIf="this.appSettings.appTopMenu && this.appSettings.appSidebarNone">
			<span class="icon-bar"></span>
			<span class="icon-bar"></span>
			<span class="icon-bar"></span>
		</button>
	</div>
	<!-- END navbar-header -->

	<!-- BEGIN mega-menu -->
	<div class="collapse d-md-block me-auto" *ngIf="this.appSettings.appHeaderMegaMenu"
		[ngClass]="{ 'd-block': (this.appSettings.appHeaderMegaMenu && this.appSettings.appHeaderMegaMenuMobileToggled) }">
		<div class="navbar-nav">
			<div class="navbar-item dropdown dropdown-lg">
				<a href="javascript:;" class="navbar-link dropdown-toggle d-flex align-items-center"
					data-bs-toggle="dropdown">
					<i class="fa fa-th-large fa-fw me-1"></i>
					<span class="d-lg-inline d-md-none">Mega</span>
					<b class="caret ms-1"></b>
				</a>
				<div class="dropdown-menu dropdown-menu-lg">
					Content here
				</div>
			</div>
			<div class="navbar-item">
				<a href="javascript:;" class="navbar-link d-flex align-items-center">
					<i class="fa fa-gem fa-fw me-1"></i>
					<span class="d-lg-inline d-md-none">Client</span>
				</a>
			</div>
			<div class="navbar-item dropdown">
				<a href="javascript:;" class="navbar-link dropdown-toggle d-flex align-items-center"
					data-bs-toggle="dropdown">
					<i class="fa fa-database fa-fw me-1"></i>
					<span class="d-lg-inline d-md-none">New</span>
					<b class="caret ms-1"></b>
				</a>
				<div class="dropdown-menu">
					<a href="javascript:;" class="dropdown-item">Action</a>
					<a href="javascript:;" class="dropdown-item">Another action</a>
					<a href="javascript:;" class="dropdown-item">Something else here</a>
					<div class="dropdown-divider"></div>
					<a href="javascript:;" class="dropdown-item">Separated link</a>
					<div class="dropdown-divider"></div>
					<a href="javascript:;" class="dropdown-item">One more separated link</a>
				</div>
			</div>
		</div>
	</div>
	<div class="navbar-nav">
		<div class="navbar-item navbar-form">
			<div class="input-group" *ngIf="roleName === 'store owner' || roleName === 'super admin'">
				<input #searchInput type="search" name="search" class="form-control" placeholder="Search product..."
					autocomplete="off" />
				<button type="button" class="btn sd-custom-btn rounded-2 btn-sm" aria-label="Search"
					(click)="onGlobalSearch(searchInput.value)">
					<i class="fa-solid fa-search"></i>
				</button>
			</div>
		</div>

		<div class="navbar-item navbar-form" *ngIf="currentUser?.userAccessibleStoreList?.length > 1">
			<div class="form-group">
				<ng-select id="StoreIds" [ngModelOptions]="{ standalone: true }"
					[items]="currentUser?.userAccessibleStoreList" bindLabel="text" bindValue="value"
					[(ngModel)]="selectedStoreId" (change)="onStoreChange($event)" placeholder="Select Store"
					dropdownPosition="bottom" style="width: 200px;">
				</ng-select>
			</div>
		</div>


		<div class="navbar-item dropdown" *ngIf="this.appSettings.appHeaderLanguageBar">
			<a href="javascript:;" class="navbar-link dropdown-toggle" data-bs-toggle="dropdown">
				<span class="fi fi-us" title="us"></span>
				<span class="d-none d-sm-inline ms-1">EN</span> <b class="caret"></b>
			</a>
			<div class="dropdown-menu">
				<a href="javascript:;" class="dropdown-item"><span class="fi fi-us me-2" title="us"></span> English</a>
				<a href="javascript:;" class="dropdown-item"><span class="fi fi-cn me-2" title="cn"></span> Chinese</a>
				<a href="javascript:;" class="dropdown-item"><span class="fi fi-jp me-2" title="jp"></span> Japanese</a>
				<a href="javascript:;" class="dropdown-item"><span class="fi fi-be me-2" title="be"></span> Belgium</a>
				<div class="dropdown-divider"></div>
				<a href="javascript:;" class="dropdown-item text-center">more options</a>
			</div>
		</div>
		<button type="button" class="navbar-link position-relative" (click)="goToReleaseNotes()"
			aria-label="What's new" title="What's new"
			style="background: transparent; border: 0; padding: 0; margin-top: 7px; margin-right: 10px; display: inline-flex; align-items: center; justify-content: center;">
			<i class="fa-solid fa-bullhorn fs-5"></i>
		</button>

		<button type="button" class="navbar-link position-relative notification-trigger" (click)="toggleNotificationPanel()"
			aria-label="Open notifications"
			style="background: transparent; border: 0; padding: 0; margin-top: 7px; display: inline-flex; align-items: center; justify-content: center;">
			<i class="fa-regular fa-bell fs-5"></i>
			<span class="badge bg-danger position-absolute top-0 start-100 translate-middle" *ngIf="unreadCount > 0">{{
				unreadCount }}</span>
		</button>

		<div class="navbar-item navbar-user dropdown">
			<a href="javascript:;" class="navbar-link dropdown-toggle d-flex align-items-center justify-content-center"
				data-bs-toggle="dropdown">
				<i class="fa-solid fa-user-circle text-primary fs-4 me-1" style="color: #29245A !important;"></i>
			</a>

			<div class="dropdown-menu dropdown-menu-end me-1 shadow-sm border-0 rounded-3">
				<a href="javascript:;" class="dropdown-item d-flex align-items-center" (click)="goToProfile()">
					<i class="fa-regular fa-id-badge me-2 text-secondary"></i> User Profile
				</a>

				<div class="dropdown-divider"></div>

				<a href="javascript:;" class="dropdown-item d-flex align-items-center text-danger"
					(click)="logoutUser()">
					<i class="fa-solid fa-right-from-bracket me-2"></i> Log Out
				</a>
			</div>
		</div>

		<div class="navbar-divider d-none d-md-block" *ngIf="this.appSidebarTwo"></div>
		<div class="navbar-item d-none d-md-block" *ngIf="this.appSidebarTwo">
			<a href="javascript:;" (click)="toggleAppSidebarEnd()" class="navbar-link icon">
				<i class="fa fa-th"></i>
			</a>
		</div>
	</div>
	<!-- END nav -->
</div>
<!-- END #header -->